<div class="menu-comparacion-card">
  @if (!isExpanded()) {
    <div class="menu-comparacion-title textos-title-small">
      Pantalla dividida
    </div>
  }
  <div class="info-close">
    <div class="info-button" [appTooltip]="info">
      <span class="material-symbols-rounded">info</span>
    </div>
    <button
      type="button"
      class="toggle-button"
      (click)="toggleExpanded()"
      aria-label="Expandir o contraer"
      [attr.aria-expanded]="isExpanded()">
      <span class="material-symbols-rounded" [class.expanded]="isExpanded()">
        keyboard_arrow_down
      </span>
    </button>
    <div class="close-button" (click)="onCloseButton()">
      <span class="material-symbols-rounded">close</span>
    </div>
  </div>

  <div class="menu-comparacion-collapsible" [class.collapsed]="!isExpanded()">
    <div class="menu-comparacion-collapsible-inner">
      <div class="controles-comparacion">
        <!-- Controles lado izquierdo (A) -->
        <div class="comparacion-area">
          <span class="textos-title-small">Pantalla izquierda</span>
          <div class="controles-lado">
            <app-chips-container>
              <app-selector-chip
                [data]="indices"
                [tooltips]="indiceTooltips"
                label="Índice A"
                selectedLabelPrefix="Índice: "
                [formControl]="leftFormGroup()?.get('indice')">
              </app-selector-chip>
              <app-selector-datepicker
                class="datepicker-comparacion"
                [formControl]="leftFormGroup()?.get('fecha')">
              </app-selector-datepicker>
              <app-selector-chip
                [data]="escalas"
                [unselectOption]="false"
                label="Escala A"
                [formControl]="leftFormGroup()?.get('escala')">
              </app-selector-chip>
            </app-chips-container>
          </div>
        </div>

        <!-- Separador visual -->
        <div class="comparacion-separador"></div>

        <!-- Controles lado derecho (B) -->
        <div class="comparacion-area">
          <span class="textos-title-small">Pantalla derecha</span>
          <div class="controles-lado">
            <app-chips-container>
              <app-selector-chip
                [data]="indices"
                [tooltips]="indiceTooltips"
                label="Índice B"
                selectedLabelPrefix="Índice: "
                [formControl]="rightFormGroup()?.get('indice')">
              </app-selector-chip>
              <app-selector-datepicker
                class="datepicker-comparacion"
                [formControl]="rightFormGroup()?.get('fecha')">
              </app-selector-datepicker>
              <app-selector-chip
                [data]="escalas"
                [unselectOption]="false"
                label="Escala B"
                [formControl]="rightFormGroup()?.get('escala')">
              </app-selector-chip>
            </app-chips-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #info>
  <div class="info-tooltip">
    <span class="material-symbols-rounded" style="font-size: 16px">info</span>
    <span class="textos-body-small">
      Estas en Modo de Comparación. Utiliza los filtros a la izquierda y derecha
      para comparar distintos índices, fechas o escalas.</span
    >
  </div>
</ng-template>
